import { Type } from '@sinclair/typebox';
import { UnitTypeNames } from '@stickerapp-org/nomisma';
export const FamilyResponseSchema = Type.Object({
    id: Type.Number(),
    name: Type.String(),
    unitType: Type.Enum(UnitTypeNames),
    constraintCollectionId: Type.Union([Type.Null(), Type.Number()]),
    filterCollectionId: Type.Union([Type.Null(), Type.Number()]),
    minUnitsConfigId: Type.Union([Type.Null(), Type.Number()]),
    priceProviderId: Type.Union([Type.Null(), Type.Number()]),
    quantityListCollectionsId: Type.Union([Type.Null(), Type.Number()]),
    versionId: Type.Number(),
});
export const CreateFamilySchema = Type.Omit(FamilyResponseSchema, ['id']);
export const UpdateFamilySchema = Type.Partial(Type.Omit(CreateFamilySchema, ['versionId']));
//# sourceMappingURL=families.js.map